export const DOMAIN_REGISTRATION_DEFAULT_YEARS = 3;